import { z } from "zod";

// Domain enums — mirror the Prisma enums / backend DTOs. These are the source of
// truth for the frontend and are shaped to lift verbatim into @echorai/schemas
// (Phase 2, ADR-0008).

export const removalStatus = z.enum([
  "todo",
  "submitted",
  "confirmed",
  "failed",
  "not_found",
  "needs_customer_action",
]);
export type RemovalStatus = z.infer<typeof removalStatus>;

export const siteMethod = z.enum([
  "web_form",
  "email",
  "postal",
  "bankid_required",
]);
export type SiteMethod = z.infer<typeof siteMethod>;

export const evidenceType = z.enum([
  "fullmakt",
  "screenshot",
  "email",
  "letter",
  "report",
]);
export type EvidenceType = z.infer<typeof evidenceType>;

export const caseStatus = z.enum([
  "draft",
  "active",
  "monitoring",
  "completed",
  "cancelled",
]);
export type CaseStatus = z.infer<typeof caseStatus>;

export const subscriberType = z.enum(["personal", "business"]);
export type SubscriberType = z.infer<typeof subscriberType>;
